export default __webpack_public_path__ + "static/media/vantage90_logo_inline.72dd1b95.svg";